export const GET_TIMEZONES = "GET_TIMEZONES";
export const GET_TIMEZONE_BY_ID = "GET_TIMEZONE_BY_ID";
export const UPDATE_TIMEZONE = "UPDATE_TIMEZONE";
export const DELETE_TIMEZONE = "DELETE_TIMEZONE";
export const CREATE_TIMEZONE = "CREATE_TIMEZONE";
